import * as data from '../../version.json';

export const environment = {
  dataServicePort: "8080",
  production: true,
  ssl: true,
  "version": data.version
};
